// src/refactor/RefactorHooks.js

/**
 * RefactorHooks registriert Übergangs-Eventhandler für Altlogik
 * z.B. hoverThumb, legacy search, timeouts etc.
 * und dient als Sammelstelle für refactor:* Events
 */

export function registerRefactorHooks(mediator) {
    // Beispiel: Legacy HoverThumb Integration
    mediator.subscribe('refactor:delegated:hoverthumb', ({ id, x, y }) => {
       console.debug('[refactor] HoverThumb handled by legacy logic');
       window?.HoverThumb?.over?.(id, x, y);
    });

    // Beispiel: Timeout-Debug-Fallback
    mediator.subscribeWildcard('refactor:timeout:*', (event, data) => {
       console.debug(`[refactor-timeout] ${event}`, data);
        // Hier könnten auch Marker resettet, Maps gefittet oder Cluster aktualisiert werden
    });

    // Optional: sauchtrigger über Legacy-API
    mediator.subscribe('refactor:legacy:search:trigger', (data) => {
       console.debug('[refactor] legacy search triggered: ', data);
       window?.ToBeSorted?.searchCalls?.push?.(data);
    });
}